/**
 * Created by fers on 05.02.16.
 */

import PureRenderMixin from 'react-addons-pure-render-mixin';
import {FormattedMessage, IntlShape} from 'react-intl';

import React from 'react';
import PropTypes from 'prop-types';
import LoadingButton from './LoadingButton.react';
import * as BrowserPermission from "../BrowserPermission";

export default class extends React.Component {
    static propTypes = {
        asLink: PropTypes.bool,
        className: PropTypes.string,
        data: PropTypes.object.isRequired,
        metadata: PropTypes.object.isRequired,
        organisationId: PropTypes.string,
		title: PropTypes.any,
        urlMapping: PropTypes.object.isRequired,
    };

    constructor() {
        super();
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    static contextTypes = {
        router: PropTypes.object
    };

    onEditClick = (event) => {
        let { urlMapping, metadata, data } = this.props;

        let path = urlMapping.getUrl(metadata, "edit", data);
        this.context.router.push(path);
    };

    render() {
		const {title} = this.props;

        if (this.props.metadata.canUserUpdate(this.props.data) && this.props.metadata.canUpdate(BrowserPermission.getPermissionObject(), this.props.data, this.props.organisationId)) {
            if (this.props.asLink) {
                return (
                    <a href="#" onClick={this.onEditClick}>
                        <i aria-hidden="true" className="fa fa-fw fa-edit"></i>{" "}
                        {title || <FormattedMessage defaultMessage="Edit" id="edit"/> }
                    </a>
                );
            } else {
                return (
                    <LoadingButton className={"btn btn-default " + (this.props.className ? this.props.className : "")} onClick={this.onEditClick}>
                        <i aria-hidden="true" className="fa fa-edit"></i>{" "}
                        {title || <FormattedMessage defaultMessage="Edit" id="edit"/> }
                    </LoadingButton>
                );
            }
        } else {
            return null;
        }
    }
}
